import React from 'react'
import { useLocation } from 'react-router-dom';
export default function Props() {
    const location = useLocation();
    const { checkInDate, checkOutDate, rooms } = location.state || {}; // Destructure state
  
    return (
      <div>
        <h2>Booking Details</h2>
        <p>Check-In Date: {checkInDate}</p>
        <p>Check-Out Date: {checkOutDate}</p>
  
        <h3>Rooms</h3>
        {rooms && rooms.map((room, index) => (
          <div key={index}>
            <p>Room {index + 1}: {room.adults} Adults, {room.children} Children</p>
          </div>
        ))}
      </div>
    );
}
